export function showPwaFlash(message, type = 'info') {
    let flashContainer = document.getElementById('flash')

    if (!flashContainer) {
        flashContainer = document.createElement('div')
        flashContainer.id = 'flash'
        flashContainer.className = 'flash flash-container'
        document.body.appendChild(flashContainer)
    }

    let alertType = type
    if (type === 'notice' || type === 'success') alertType = 'info'
    if (type === 'alert' || type === 'error' || type === 'offline') alertType = 'danger'

    const flashEl = document.createElement('div')

    flashEl.className = `alert alert-${alertType} flash__message`
    flashEl.setAttribute('role', 'alert')
    flashEl.setAttribute('data-controller', 'flash')
    flashEl.setAttribute('data-action', 'animationend->flash#remove')

    flashEl.innerText = message

    flashContainer.appendChild(flashEl)
}